import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Title, Text, Box } from '@nerdwallet/currency';
import BackgroundColor from '../background-color/background-color';
import classColor from '../../lib/parse-color';
import titleFormatting from '../standard-hero/lib/parse-hero-formatting';

import './logo-salad.less';

const LogoSalad = ({
  bgOptions,
  title,
  subtitle,
  desktopLogos,
  mobileLogos,
  textColor,
  bigLogos,
}) => {
  const renderLogos = (logos) =>
    logos.map(({ alt, src }) => (
      <Box
        className={classNames('logo-salad__logo-item', {
          'spaced-layout': bigLogos,
        })}
      >
        <img
          className={classNames('logo-salad__logo', { 'big-logo': bigLogos })}
          alt={alt || src}
          src={src}
          key={src}
        />
      </Box>
    ));
  return (
    <BackgroundColor bgOptions={bgOptions}>
      {(backgroundColor) => (
        <Box
          className="logo-salad"
          style={{
            backgroundColor,
          }}
        >
          <Box className="logo-salad__content">
            <Title
              className={classNames([
                'logo-salad-title',
                classColor(textColor),
              ])}
              size="small"
            >
              {titleFormatting(title)}
            </Title>
            {subtitle && (
              <Box className="logo-salad-subtitle">
                <Text>{subtitle}</Text>
              </Box>
            )}
            <Box
              className={classNames('logo-salad__desktop', {
                'spaced-layout': bigLogos,
              })}
            >
              {renderLogos(desktopLogos)}
            </Box>
            <Box
              className={classNames('logo-salad__mobile', {
                'spaced-layout': bigLogos,
              })}
            >
              {renderLogos(mobileLogos || desktopLogos)}
            </Box>
          </Box>
        </Box>
      )}
    </BackgroundColor>
  );
};

LogoSalad.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  desktopLogos: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
    })
  ),
  mobileLogos: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
    })
  ),
  ...BackgroundColor.propTypes,
  textColor: PropTypes.string,
};

LogoSalad.defaultProps = {
  desktopLogos: [],
  ...BackgroundColor.defaultProps,
};

LogoSalad.displayName = 'LogoSalad';

export default LogoSalad;
